
<div class="chart-shell" [ngStyle]="{ height: popUp ? '28em' : height }">
	<div [id]="'chart-container'+id" class="chart-canvas"></div>
	<div
		class="chart-scrollbar"
		role="scrollbar"
		aria-orientation="horizontal"
		aria-label="Scroll chart categories"
		[attr.aria-controls]="'chart-container' + id"
		[attr.aria-valuemin]="0"
		[attr.aria-valuemax]="maxScrollOffset"
		[attr.aria-valuenow]="scrollOffset"
		[attr.aria-disabled]="maxScrollOffset === 0"
		[attr.tabindex]="maxScrollOffset > 0 ? 0 : -1"
		[style.background-color]="scrollbarTrackColor"
		(pointerdown)="onScrollbarPointerDown($event)"
		(pointermove)="onScrollbarPointerMove($event)"
		(pointerup)="onScrollbarPointerUp($event)"
		(pointercancel)="onScrollbarPointerUp($event)"
		(keydown)="onScrollbarKeydown($event)"
	>
		<div
			class="chart-scrollbar-thumb"
			[style.width.%]="scrollThumbWidthPercent"
			[style.left.%]="scrollThumbLeftPercent"
			[style.background-color]="scrollbarThumbColor"
		></div>
	</div>
</div>

<script src="https://code.highcharts.com/modules/pattern-fill.js"></script>
<script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
